import { HttpErrorHandlerFn, isUnsupportedMediaType } from '@web/common';

/* prettier-ignore */
export const UnsupportedMediaTypeErrorHandler: HttpErrorHandlerFn = (response) => {
  if (isUnsupportedMediaType(response)) {
    return ['Nieobsługiwany typ zawartości żądania. Proszę skontaktować się z Administratorem.'];
  }

  return null;
};
